import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../../services/message.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'ngx-widget-setup-energy',
    templateUrl: './widget.setup.energy.component.html',
    styleUrls: ['./widget.setup.energy.component.scss'],
})

export class WidgetSetupEnergyComponent implements OnInit {

    form: FormGroup;
    data: any;
    availableSensors: Array<String> = [];
    availableSensors2: Array<String> = [];
    addWidget: boolean;

    constructor(private activeModal: NgbActiveModal,
                private messageService: MessageService,
                private formBuilder: FormBuilder) {

        const self = this;

        this.data = {
            name: 'Energy widget',
        };

        // console.log(this.config);


        this.messageService.getGatewayPhisicalDevices(function(status, obj){

            // console.log({status, obj});

            if (status === true) {
                for (let i = 0; i < obj.length; ++i) {

                    const dev = obj[i];

                     if (dev.vendor === 'EMON' && dev.deviceType === 1) {
                         const sSource = dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId + ':';

                         self.availableSensors.push(sSource + 'ct1');
                         self.availableSensors.push(sSource + 'ct2');
                         self.availableSensors.push(sSource + 'ct3');
                         self.availableSensors.push(sSource + 'ct4');
                         // self.availableSensors.push(sSource + 'freeram');

                         self.availableSensors2.push(sSource + 'vrms');
                     }
                }
            }
        });

    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            widgetName: [null, Validators.required],
            source: [null, Validators.required],
            sourcePower: [null, Validators.required],
        });





        if (this.data['id'] !== undefined) {
            this.addWidget = false;
        }else {
            this.addWidget = true;
        }
    }

    onSubmit() {
        // console.log(JSON.stringify(this.data));

        this.messageService.saveWidget('energy', this.data);
        this.messageService.syncAllWidgets();
        this.activeModal.close();
        // window.location.reload();

    }

    closeModal() {
        this.activeModal.close();
    }


    private pad(i: number): string {
        return i < 10 ? `0${i}` : `${i}`;
    }

}



// WEBPACK FOOTER //
// /app/src/app/@core/component/add-widget/modal/widget.setup.energy.component.ts